import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutHero from "../assets/villa1.jpeg";
import img1 from "../assets/villa14.jpeg";
import img2 from "../assets/villa11.jpeg";

function About() {
    useEffect(() => {
        AOS.init({ duration: 900, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[40vh] w-full">
                <img
                    src={aboutHero}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1 data-aos="fade-up" className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3">
                        About Us
                    </h1>
                </div>
            </section>

            {/* ================= RESORT SECTION 1 ================= */}
            <section className="relative bg-white py-12 sm:py-12 lg:py-12 px-4 sm:px-6 lg:px-16">
                <div className="mx-auto max-w-5xl grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">

                    {/* ===== Left Text Content ===== */}
                    <div data-aos="fade-right">
                        <span className="block w-16 h-[2px] bg-orange-400 mb-4"></span>

                        <h2 className="text-3xl sm:text-5xl font-bold mb-6 text-gray-800">
                            Three Tree Villa by Habarana
                        </h2>

                        <p className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl">
                            Relax by the pool, practice yoga, savor authentic local flavors, and soak in the serenity of nature. Our cozy A-frame villas at Three Tree Villa in Habarana are perfect for couples and families, surrounded by lush greenery and a tranquil blue lotus pond 🌸.
                        </p>

                        <p className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl">
                            Conveniently located near Habarana’s cultural and natural landmarks, including Sigiriya Rock, Pidurangala Rock, and Habarana Lake, Three Tree Villa is nestled within a forest reserve teeming with native wildlife—offering a peaceful retreat with easy access to Sri Lanka’s iconic attractions.
                        </p>
                    </div>

                    {/* ===== Right Image ===== */}
                    <div data-aos="fade-left" className="flex justify-center">
                        <img
                            src={img1}
                            alt="Three Tree Villa by Habarana"
                            className="rounded-lg shadow-lg w-full max-w-[500px] h-[400px] sm:h-[500px] md:h-[500px] object-cover"
                        />
                    </div>

                </div>
            </section>

            {/* ================= RESORT SECTION 2 ================= */}
            <section className="relative bg-white py-12 sm:py-12 lg:py-12 px-4 sm:px-6 lg:px-16">
                <div className="mx-auto max-w-5xl grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">

                    {/* ===== Left Text Content ===== */}
                    <div data-aos="fade-left" className="flex justify-center">
                        <img
                            src={img2}
                            alt="Three Tree Villa by Habarana"
                            className="rounded-lg shadow-lg w-full max-w-[500px] h-[400px] sm:h-[500px] md:h-[500px] object-cover"
                        />
                    </div>

                    {/* ===== Right Image ===== */}
                    <div data-aos="fade-right">

                        <p className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl">
                            At Three Tree Villa in Habarana, families and couples can unwind in eco-friendly villas designed for comfort and convenience. Enjoy delicious local and international cuisine, 24/7 guest support, and free Wi-Fi throughout your stay. For added ease, our airport shuttle service ensures a smooth journey from anywhere in Sri Lanka.
                        </p>

                        <p className="mt-6 text-gray-600 leading-relaxed text-base sm:text-lg md:text-xl">
                            Immerse yourself in the sounds of nature as you relax in your private pool, or savor our continental menu while enjoying panoramic views of Habarana’s iconic cultural and natural landmarks, including Sigiriya Rock, Pidurangala Rock, and Habarana Lake.
                        </p>

                    </div>

                </div>
            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94764806045?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20villa."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>

        </div>
    );
}

export default About;
